import { GRAPH_AIRBYTE_QUERIES } from 'graphql/airbyte'
import type { AirbyteQueriesName, AirbyteQueriesData, AirbyteQueriesVariables } from 'graphql/airbyte/types'
import { buildLazyQueryHook } from 'lib/apollo-client/builders'

export const useAirbyteLazyQueries = buildLazyQueryHook<
  AirbyteQueriesName,
  AirbyteQueriesVariables,
  AirbyteQueriesData
>(GRAPH_AIRBYTE_QUERIES)
